import { transformError as sdkTransformError } from '@wix/sdk-runtime/transform-error';
import { queryBuilder } from '@wix/sdk-runtime/query-builder';
import { renameKeysFromSDKRequestToRESTRequest, renameKeysFromRESTResponseToSDKResponse, } from '@wix/sdk-runtime/rename-all-nested-keys';
import * as ambassadorWixBookingsServicesV2Service from './bookings-services-v2-service-services.http';
// @ts-ignore
import { transformSDKAddressToRESTAddress } from '@wix/sdk-runtime/transformations/address';
import { transformRESTAddressToSDKAddress } from '@wix/sdk-runtime/transformations/address';
import { transformSDKImageToRESTImage } from '@wix/sdk-runtime/transformations/image';
import { transformRESTImageToSDKImage } from '@wix/sdk-runtime/transformations/image';
import { transformSDKPageURLV2ToRESTPageURLV2 } from '@wix/sdk-runtime/transformations/page-url-v2';
import { transformRESTPageURLV2ToSDKPageURLV2 } from '@wix/sdk-runtime/transformations/page-url-v2';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
export var ServiceType;
(function (ServiceType) {
    ServiceType["UNKNOWN_SERVICE_TYPE"] = "UNKNOWN_SERVICE_TYPE";
    /** Service is an appointment. */
    ServiceType["APPOINTMENT"] = "APPOINTMENT";
    /** Service is a class. */
    ServiceType["CLASS"] = "CLASS";
    /** Service is a course. */
    ServiceType["COURSE"] = "COURSE";
})(ServiceType || (ServiceType = {}));
export var RateType;
(function (RateType) {
    RateType["UNKNOWN_RATE_TYPE"] = "UNKNOWN_RATE_TYPE";
    /** The service has a fixed price. */
    RateType["FIXED"] = "FIXED";
    /** The service has a custom price, expressed as a price description. */
    RateType["CUSTOM"] = "CUSTOM";
    /** This service is offered with a set of different prices based on different terms. */
    RateType["VARIED"] = "VARIED";
    /** This service is offered free of charge. */
    RateType["NO_FEE"] = "NO_FEE";
})(RateType || (RateType = {}));
export var LocationTypeEnumLocationType;
(function (LocationTypeEnumLocationType) {
    LocationTypeEnumLocationType["UNKNOWN_LOCATION_TYPE"] = "UNKNOWN_LOCATION_TYPE";
    /** The location is unique to this service and isn't defined as one of the business locations. `CUSTOM` is the equivalent of the `OWNER_CUSTOM` location type in [Schedules & Sessions API](https://dev.wix.com/api/rest/wix-bookings/schedules-and-sessions). */
    LocationTypeEnumLocationType["CUSTOM"] = "CUSTOM";
    /** The location is one of the business locations available using the Business Info [Locations API](https://dev.wix.com/api/rest/business-info/locations). */
    LocationTypeEnumLocationType["BUSINESS"] = "BUSINESS";
    /** The location can be determined by the customer and is not set up beforehand. This is applicable to services of type `APPOINTMENT` only. */
    LocationTypeEnumLocationType["CUSTOMER"] = "CUSTOMER";
})(LocationTypeEnumLocationType || (LocationTypeEnumLocationType = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
export var RequestedFields;
(function (RequestedFields) {
    RequestedFields["UNKNOWN_REQUESTED_FIELD"] = "UNKNOWN_REQUESTED_FIELD";
    /** When passed, `service.staff_members` is returned */
    RequestedFields["STAFF_MEMBER_DETAILS"] = "STAFF_MEMBER_DETAILS";
    /** When passed, `service.service_resources.resource_type.name` is */
    RequestedFields["RESOURCE_TYPE_DETAILS"] = "RESOURCE_TYPE_DETAILS";
})(RequestedFields || (RequestedFields = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var SortType;
(function (SortType) {
    SortType["COUNT"] = "COUNT";
    SortType["VALUE"] = "VALUE";
})(SortType || (SortType = {}));
export var SortDirection;
(function (SortDirection) {
    SortDirection["DESC"] = "DESC";
    SortDirection["ASC"] = "ASC";
})(SortDirection || (SortDirection = {}));
export var MissingValues;
(function (MissingValues) {
    MissingValues["EXCLUDE"] = "EXCLUDE";
    MissingValues["INCLUDE"] = "INCLUDE";
})(MissingValues || (MissingValues = {}));
export var ScalarType;
(function (ScalarType) {
    ScalarType["UNKNOWN_SCALAR_TYPE"] = "UNKNOWN_SCALAR_TYPE";
    ScalarType["COUNT_DISTINCT"] = "COUNT_DISTINCT";
    ScalarType["MIN"] = "MIN";
    ScalarType["MAX"] = "MAX";
    ScalarType["SUM"] = "SUM";
    ScalarType["AVG"] = "AVG";
})(ScalarType || (ScalarType = {}));
export var NestedAggregationType;
(function (NestedAggregationType) {
    NestedAggregationType["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
    NestedAggregationType["VALUE"] = "VALUE";
    NestedAggregationType["RANGE"] = "RANGE";
    NestedAggregationType["SCALAR"] = "SCALAR";
    NestedAggregationType["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
})(NestedAggregationType || (NestedAggregationType = {}));
export var DateHistogramAggregationInterval;
(function (DateHistogramAggregationInterval) {
    DateHistogramAggregationInterval["UNKNOWN_INTERVAL"] = "UNKNOWN_INTERVAL";
    /** Yearly interval */
    DateHistogramAggregationInterval["YEAR"] = "YEAR";
    /** Monthly interval */
    DateHistogramAggregationInterval["MONTH"] = "MONTH";
    /** Weekly interval */
    DateHistogramAggregationInterval["WEEK"] = "WEEK";
    /** Daily interval */
    DateHistogramAggregationInterval["DAY"] = "DAY";
    /** Hourly interval */
    DateHistogramAggregationInterval["HOUR"] = "HOUR";
    /** Minute interval */
    DateHistogramAggregationInterval["MINUTE"] = "MINUTE";
    /** Second interval */
    DateHistogramAggregationInterval["SECOND"] = "SECOND";
})(DateHistogramAggregationInterval || (DateHistogramAggregationInterval = {}));
export var AggregationType;
(function (AggregationType) {
    AggregationType["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
    AggregationType["VALUE"] = "VALUE";
    AggregationType["RANGE"] = "RANGE";
    AggregationType["SCALAR"] = "SCALAR";
    AggregationType["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
    AggregationType["NESTED"] = "NESTED";
})(AggregationType || (AggregationType = {}));
export var Mode;
(function (Mode) {
    /** Any */
    Mode["OR"] = "OR";
    /** All */
    Mode["AND"] = "AND";
})(Mode || (Mode = {}));
export var Action;
(function (Action) {
    Action["UNKNOWN_ACTION_TYPE"] = "UNKNOWN_ACTION_TYPE";
    /**
     * Keep future sessions at their current location. This is the default.
     * Note: The location will be set directly on the session. i.e, if the location is currently inherited from the schedule, the inheritance will be overridden.
     */
    Action["KEEP_AT_CURRENT_LOCATION"] = "KEEP_AT_CURRENT_LOCATION";
    /**
     * Move future sessions to a new location.
     * The new location must be specified in the availability locations to set ('SetAvailabilityLocationsRequest.locations').
     */
    Action["MOVE_TO_LOCATION"] = "MOVE_TO_LOCATION";
    /**
     * Delete future sessions.
     * Currently not supported.
     */
    Action["DELETE"] = "DELETE";
})(Action || (Action = {}));
export var InvalidSlugError;
(function (InvalidSlugError) {
    InvalidSlugError["UNKNOWN_SLUG_ERROR"] = "UNKNOWN_SLUG_ERROR";
    /** The provided slug name contains illegal characters. */
    InvalidSlugError["SLUG_CONTAINS_ILLEGAL_CHARACTERS"] = "SLUG_CONTAINS_ILLEGAL_CHARACTERS";
    /** The provided slug name already exists for another service. */
    InvalidSlugError["SLUG_ALREADY_EXISTS"] = "SLUG_ALREADY_EXISTS";
})(InvalidSlugError || (InvalidSlugError = {}));
export var CloneErrors;
(function (CloneErrors) {
    CloneErrors["UNKNOWN_CLONE_ERROR"] = "UNKNOWN_CLONE_ERROR";
    /** Failed to clone sessions of active service's schedule */
    CloneErrors["SESSIONS"] = "SESSIONS";
    /** Failed to clone service's options and variants even though source service have them */
    CloneErrors["OPTIONS_AND_VARIANTS"] = "OPTIONS_AND_VARIANTS";
    /** Failed to clone service's form */
    CloneErrors["FORM"] = "FORM";
    /** Failed to clone pricing plans connected to the source service */
    CloneErrors["PRICING_PLANS"] = "PRICING_PLANS";
})(CloneErrors || (CloneErrors = {}));
export var CategoryStatus;
(function (CategoryStatus) {
    /** The category is created. */
    CategoryStatus["CREATED"] = "CREATED";
    /** The category is deleted. */
    CategoryStatus["DELETED"] = "DELETED";
})(CategoryStatus || (CategoryStatus = {}));
export var CategoryNotificationEvent;
(function (CategoryNotificationEvent) {
    CategoryNotificationEvent["Updated"] = "Updated";
    CategoryNotificationEvent["Deleted"] = "Deleted";
    CategoryNotificationEvent["Created"] = "Created";
})(CategoryNotificationEvent || (CategoryNotificationEvent = {}));
export var Day;
(function (Day) {
    /** Undefined. */
    Day["UNDEFINED"] = "UNDEFINED";
    /** Monday. */
    Day["MON"] = "MON";
    /** Tuesday. */
    Day["TUE"] = "TUE";
    /** Wednesday. */
    Day["WED"] = "WED";
    /** Thursday. */
    Day["THU"] = "THU";
    /** Friday. */
    Day["FRI"] = "FRI";
    /** Saturday. */
    Day["SAT"] = "SAT";
    /** Sunday. */
    Day["SUN"] = "SUN";
})(Day || (Day = {}));
export var Transparency;
(function (Transparency) {
    Transparency["UNDEFINED"] = "UNDEFINED";
    /** The schedule can have available slots during the session. */
    Transparency["FREE"] = "FREE";
    /** The schedule cannot have available slots during the session. Default value. */
    Transparency["BUSY"] = "BUSY";
})(Transparency || (Transparency = {}));
export var RecurringIntervalType;
(function (RecurringIntervalType) {
    /** The default value. Sessions for this interval will be of type EVENT. */
    RecurringIntervalType["UNDEFINED"] = "UNDEFINED";
    /** A recurring interval of events */
    RecurringIntervalType["EVENT"] = "EVENT";
    /** Deprecated */
    RecurringIntervalType["TIME_AVAILABILITY"] = "TIME_AVAILABILITY";
    /** A recurring interval for availability */
    RecurringIntervalType["AVAILABILITY"] = "AVAILABILITY";
})(RecurringIntervalType || (RecurringIntervalType = {}));
export var LocationType;
(function (LocationType) {
    LocationType["UNDEFINED"] = "UNDEFINED";
    LocationType["OWNER_BUSINESS"] = "OWNER_BUSINESS";
    LocationType["OWNER_CUSTOM"] = "OWNER_CUSTOM";
    LocationType["CUSTOM"] = "CUSTOM";
})(LocationType || (LocationType = {}));
/** For future use */
export var LocationStatus;
(function (LocationStatus) {
    LocationStatus["ACTIVE"] = "ACTIVE";
    LocationStatus["INACTIVE"] = "INACTIVE";
})(LocationStatus || (LocationStatus = {}));
/** For future use */
export var LocationsLocationType;
(function (LocationsLocationType) {
    LocationsLocationType["UNKNOWN"] = "UNKNOWN";
    LocationsLocationType["BRANCH"] = "BRANCH";
    LocationsLocationType["OFFICES"] = "OFFICES";
    LocationsLocationType["RECEPTION"] = "RECEPTION";
    LocationsLocationType["HEADQUARTERS"] = "HEADQUARTERS";
    LocationsLocationType["INVENTORY"] = "INVENTORY";
})(LocationsLocationType || (LocationsLocationType = {}));
/** Enumerates the days of the week. */
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek || (DayOfWeek = {}));
export var ApprovalStatus;
(function (ApprovalStatus) {
    /** Default. */
    ApprovalStatus["UNDEFINED"] = "UNDEFINED";
    /** Pending business approval. */
    ApprovalStatus["PENDING"] = "PENDING";
    /** Approved by the business. */
    ApprovalStatus["APPROVED"] = "APPROVED";
    /** Declined by the business. */
    ApprovalStatus["DECLINED"] = "DECLINED";
})(ApprovalStatus || (ApprovalStatus = {}));
export var ScheduleStatus;
(function (ScheduleStatus) {
    ScheduleStatus["UNDEFINED"] = "UNDEFINED";
    /** The default value when the schedule is created. */
    ScheduleStatus["CREATED"] = "CREATED";
    /** The schedule has been canceled. */
    ScheduleStatus["CANCELLED"] = "CANCELLED";
})(ScheduleStatus || (ScheduleStatus = {}));
export var ConferenceType;
(function (ConferenceType) {
    ConferenceType["UNDEFINED"] = "UNDEFINED";
    /** API-generated online meeting. */
    ConferenceType["ONLINE_MEETING_PROVIDER"] = "ONLINE_MEETING_PROVIDER";
    /** User-defined meeting. */
    ConferenceType["CUSTOM"] = "CUSTOM";
})(ConferenceType || (ConferenceType = {}));
export var CalendarType;
(function (CalendarType) {
    CalendarType["UNDEFINED"] = "UNDEFINED";
    CalendarType["GOOGLE"] = "GOOGLE";
    CalendarType["I_CAL"] = "I_CAL";
    /** Use `MICROSOFT` instead. */
    CalendarType["OUTLOOK"] = "OUTLOOK";
    /** Use `MICROSOFT` instead. */
    CalendarType["OFFICE_365"] = "OFFICE_365";
    CalendarType["MICROSOFT"] = "MICROSOFT";
    CalendarType["OTHER"] = "OTHER";
})(CalendarType || (CalendarType = {}));
export var Status;
(function (Status) {
    Status["UNDEFINED"] = "UNDEFINED";
    /** The session is confirmed. Default status. */
    Status["CONFIRMED"] = "CONFIRMED";
    /**
     * The session is cancelled.
     * A cancelled session can be the cancellation of a recurring session that should no longer be displayed or a deleted single session.
     * The ListSessions returns cancelled sessions only if 'includeDelete' flag is set to true.
     */
    Status["CANCELLED"] = "CANCELLED";
})(Status || (Status = {}));
export var SessionType;
(function (SessionType) {
    SessionType["UNDEFINED"] = "UNDEFINED";
    /**
     * The session creates an event on the calendar for the owner of the schedule that the session belongs to.
     * Default type.
     */
    SessionType["EVENT"] = "EVENT";
    /** The session represents a resource's available working hours. */
    SessionType["WORKING_HOURS"] = "WORKING_HOURS";
    /** Deprecated. please use WORKING_HOURS */
    SessionType["TIME_AVAILABILITY"] = "TIME_AVAILABILITY";
    /** Deprecated. The session represents a resource's available hours. please use WORKING_HOURS */
    SessionType["AVAILABILITY"] = "AVAILABILITY";
})(SessionType || (SessionType = {}));
export var ResourceStatus;
(function (ResourceStatus) {
    ResourceStatus["UNDEFINED"] = "UNDEFINED";
    /** Default status. */
    ResourceStatus["CREATED"] = "CREATED";
    /** The resource was deleted. */
    ResourceStatus["DELETED"] = "DELETED";
    /** The resource was updated. */
    ResourceStatus["UPDATED"] = "UPDATED";
})(ResourceStatus || (ResourceStatus = {}));
export var ResourceNotificationEvent;
(function (ResourceNotificationEvent) {
    ResourceNotificationEvent["UNDEFINED"] = "UNDEFINED";
    ResourceNotificationEvent["Updated"] = "Updated";
    ResourceNotificationEvent["Deleted"] = "Deleted";
    ResourceNotificationEvent["Created"] = "Created";
    ResourceNotificationEvent["Schedule_Updated"] = "Schedule_Updated";
})(ResourceNotificationEvent || (ResourceNotificationEvent = {}));
export var BenefitType;
(function (BenefitType) {
    /** Should never be used */
    BenefitType["UNDEFINED"] = "UNDEFINED";
    /** Limited benefit type */
    BenefitType["LIMITED"] = "LIMITED";
    /** Unlimited benefit type */
    BenefitType["UNLIMITED"] = "UNLIMITED";
})(BenefitType || (BenefitType = {}));
export var Event;
(function (Event) {
    Event["Updated"] = "Updated";
    Event["Deleted"] = "Deleted";
    Event["Created"] = "Created";
})(Event || (Event = {}));
export var CrudType;
(function (CrudType) {
    CrudType["INVALID_CRUD_TYPE"] = "INVALID_CRUD_TYPE";
    CrudType["CREATE"] = "CREATE";
    CrudType["UPDATE"] = "UPDATE";
    CrudType["DELETE"] = "DELETE";
    /** Unfortunately this action is used by hibernate save in wix-war */
    CrudType["CREATE_OR_UPDATE"] = "CREATE_OR_UPDATE";
})(CrudType || (CrudType = {}));
/** Where the extra text should be displayed: before, after or instead of the actual address. */
export var PlacementType;
(function (PlacementType) {
    PlacementType["BEFORE"] = "BEFORE";
    PlacementType["AFTER"] = "AFTER";
    PlacementType["REPLACE"] = "REPLACE";
})(PlacementType || (PlacementType = {}));
export var ResolutionMethod;
(function (ResolutionMethod) {
    ResolutionMethod["QUERY_PARAM"] = "QUERY_PARAM";
    ResolutionMethod["SUBDOMAIN"] = "SUBDOMAIN";
    ResolutionMethod["SUBDIRECTORY"] = "SUBDIRECTORY";
})(ResolutionMethod || (ResolutionMethod = {}));
/**
 * Creates a new service.
 * @param service - Service to be created.
 * @public
 * @documentationMaturity preview
 * @requiredField service
 * @permissionId BOOKINGS.SERVICES_CREATE
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 * @returns The created service.
 */
export async function createService(service) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = transformPaths(renameKeysFromSDKRequestToRESTRequest({ service: service }), [
        {
            transformFn: transformSDKImageToRESTImage,
            paths: [
                { path: 'service.media.items.image' },
                { path: 'service.media.mainMedia.image' },
                { path: 'service.media.coverMedia.image' },
                { path: 'service.staffMembers.mainMedia.image' },
                { path: 'service.staffMemberDetails.staffMembers.mainMedia.image' },
            ],
        },
        {
            transformFn: transformSDKAddressToRESTAddress,
            paths: [
                { path: 'service.locations.calculatedAddress' },
                { path: 'service.locations.business.address' },
                { path: 'service.locations.custom.address' },
            ],
        },
        {
            transformFn: transformSDKPageURLV2ToRESTPageURLV2,
            paths: [
                { path: 'service.urls.servicePage' },
                { path: 'service.urls.bookingPage' },
                { path: 'service.urls.calendarPage' },
            ],
        },
    ]);
    const reqOpts = ambassadorWixBookingsServicesV2Service.createService(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'service.media.items.image' },
                    { path: 'service.media.mainMedia.image' },
                    { path: 'service.media.coverMedia.image' },
                    { path: 'service.staffMembers.mainMedia.image' },
                    { path: 'service.staffMemberDetails.staffMembers.mainMedia.image' },
                ],
            },
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [
                    { path: 'service.locations.calculatedAddress' },
                    { path: 'service.locations.business.address' },
                    { path: 'service.locations.custom.address' },
                ],
            },
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [
                    { path: 'service.urls.servicePage' },
                    { path: 'service.urls.bookingPage' },
                    { path: 'service.urls.calendarPage' },
                ],
            },
        ]))?.service;
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { service: '$[0]' },
            singleArgumentUnchanged: false,
        }, ['service']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Retrieves a service.
 * @public
 * @documentationMaturity preview
 * @requiredField serviceId
 * @permissionId BOOKINGS.SERVICES_READ
 * @permissionScope Read Bookings - Public Data
 * @permissionScopeId SCOPE.DC-BOOKINGS.READ-BOOKINGS-PUBLIC
 * @permissionScope Manage Bookings Services and Settings
 * @permissionScopeId SCOPE.BOOKINGS.CONFIGURATION
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Read Bookings - Including Participants
 * @permissionScopeId SCOPE.DC-BOOKINGS.READ-BOOKINGS-SENSITIVE
 * @permissionScope Read Bookings - all read permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.READ-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 * @applicableIdentity VISITOR
 * @returns The retrieved service.
 */
export async function getService(serviceId) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        serviceId: serviceId,
    });
    const reqOpts = ambassadorWixBookingsServicesV2Service.getService(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'service.media.items.image' },
                    { path: 'service.media.mainMedia.image' },
                    { path: 'service.media.coverMedia.image' },
                    { path: 'service.staffMembers.mainMedia.image' },
                    { path: 'service.staffMemberDetails.staffMembers.mainMedia.image' },
                ],
            },
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [
                    { path: 'service.locations.calculatedAddress' },
                    { path: 'service.locations.business.address' },
                    { path: 'service.locations.custom.address' },
                ],
            },
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [
                    { path: 'service.urls.servicePage' },
                    { path: 'service.urls.bookingPage' },
                    { path: 'service.urls.calendarPage' },
                ],
            },
        ]))?.service;
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { serviceId: '$[0]' },
            singleArgumentUnchanged: false,
        }, ['serviceId']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Updates a service.
 *
 * [Partial
 * updates](https://dev.wix.com/api/rest/wix-bookings/bookings/patch-endpoints-and-field-masks-in-update-requests)
 * are supported.
 *
 * Each time the service is updated, `revision` increments by 1. You must
 * include the number of the existing revision when updating the service.
 * This ensures you're working with the latest service information and
 * prevents unintended overwrites.
 * @param _id - Service ID.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField service
 * @requiredField service.revision
 * @permissionId BOOKINGS.SERVICES_UPDATE
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 * @returns The updated service.
 */
export async function updateService(_id, service) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = transformPaths(renameKeysFromSDKRequestToRESTRequest({ service: { ...service, id: _id } }), [
        {
            transformFn: transformSDKImageToRESTImage,
            paths: [
                { path: 'service.media.items.image' },
                { path: 'service.media.mainMedia.image' },
                { path: 'service.media.coverMedia.image' },
                { path: 'service.staffMembers.mainMedia.image' },
                { path: 'service.staffMemberDetails.staffMembers.mainMedia.image' },
            ],
        },
        {
            transformFn: transformSDKAddressToRESTAddress,
            paths: [
                { path: 'service.locations.calculatedAddress' },
                { path: 'service.locations.business.address' },
                { path: 'service.locations.custom.address' },
            ],
        },
        {
            transformFn: transformSDKPageURLV2ToRESTPageURLV2,
            paths: [
                { path: 'service.urls.servicePage' },
                { path: 'service.urls.bookingPage' },
                { path: 'service.urls.calendarPage' },
            ],
        },
    ]);
    const reqOpts = ambassadorWixBookingsServicesV2Service.updateService(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'service.media.items.image' },
                    { path: 'service.media.mainMedia.image' },
                    { path: 'service.media.coverMedia.image' },
                    { path: 'service.staffMembers.mainMedia.image' },
                    { path: 'service.staffMemberDetails.staffMembers.mainMedia.image' },
                ],
            },
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [
                    { path: 'service.locations.calculatedAddress' },
                    { path: 'service.locations.business.address' },
                    { path: 'service.locations.custom.address' },
                ],
            },
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [
                    { path: 'service.urls.servicePage' },
                    { path: 'service.urls.bookingPage' },
                    { path: 'service.urls.calendarPage' },
                ],
            },
        ]))?.service;
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: { service: '$[1]' },
            explicitPathsToArguments: { 'service.id': '$[0]' },
            singleArgumentUnchanged: false,
        }, ['_id', 'service']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Updates multiple services.
 *
 * [Partial
 * updates](https://dev.wix.com/api/rest/wix-bookings/bookings/patch-endpoints-and-field-masks-in-update-requests)
 * are supported.
 *
 * Each time a service is updated, `revision` increments by 1. You must
 * include the number of the existing revision for each service to update.
 * This ensures you're working with the latest service information and
 * prevents unintended overwrites.
 * @public
 * @documentationMaturity preview
 * @requiredField options.services.service
 * @requiredField options.services.service._id
 * @requiredField options.services.service.revision
 * @permissionId BOOKINGS.SERVICES_UPDATE
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 */
export async function bulkUpdateServices(options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = transformPaths(renameKeysFromSDKRequestToRESTRequest({
        services: options?.services,
        returnEntity: options?.returnEntity,
    }), [
        {
            transformFn: transformSDKImageToRESTImage,
            paths: [
                { path: 'services.service.media.items.image' },
                { path: 'services.service.media.mainMedia.image' },
                { path: 'services.service.media.coverMedia.image' },
                { path: 'services.service.staffMembers.mainMedia.image' },
                {
                    path: 'services.service.staffMemberDetails.staffMembers.mainMedia.image',
                },
            ],
        },
        {
            transformFn: transformSDKAddressToRESTAddress,
            paths: [
                { path: 'services.service.locations.calculatedAddress' },
                { path: 'services.service.locations.business.address' },
                { path: 'services.service.locations.custom.address' },
            ],
        },
        {
            transformFn: transformSDKPageURLV2ToRESTPageURLV2,
            paths: [
                { path: 'services.service.urls.servicePage' },
                { path: 'services.service.urls.bookingPage' },
                { path: 'services.service.urls.calendarPage' },
            ],
        },
    ]);
    const reqOpts = ambassadorWixBookingsServicesV2Service.bulkUpdateServices(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'results.item.media.items.image' },
                    { path: 'results.item.media.mainMedia.image' },
                    { path: 'results.item.media.coverMedia.image' },
                    { path: 'results.item.staffMembers.mainMedia.image' },
                    {
                        path: 'results.item.staffMemberDetails.staffMembers.mainMedia.image',
                    },
                ],
            },
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [
                    { path: 'results.item.locations.calculatedAddress' },
                    { path: 'results.item.locations.business.address' },
                    { path: 'results.item.locations.custom.address' },
                ],
            },
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [
                    { path: 'results.item.urls.servicePage' },
                    { path: 'results.item.urls.bookingPage' },
                    { path: 'results.item.urls.calendarPage' },
                ],
            },
        ]));
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                services: '$[0].services',
                returnEntity: '$[0].returnEntity',
            },
            singleArgumentUnchanged: false,
        }, ['options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Updates multiple services by filter.
 *
 * [Partial
 * updates](https://dev.wix.com/api/rest/wix-bookings/bookings/patch-endpoints-and-field-masks-in-update-requests)
 * are supported.
 *
 * Each time a service is updated, `revision` increments by 1.
 * @param filter - Filter to identify the services that need to be updated.
 * @public
 * @documentationMaturity preview
 * @requiredField filter
 * @requiredField options
 * @requiredField options.service
 * @permissionId BOOKINGS.SERVICES_UPDATE
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 */
export async function bulkUpdateServicesByFilter(filter, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = transformPaths(renameKeysFromSDKRequestToRESTRequest({
        filter: filter,
        service: options?.service,
    }), [
        {
            transformFn: transformSDKImageToRESTImage,
            paths: [
                { path: 'service.media.items.image' },
                { path: 'service.media.mainMedia.image' },
                { path: 'service.media.coverMedia.image' },
                { path: 'service.staffMembers.mainMedia.image' },
                { path: 'service.staffMemberDetails.staffMembers.mainMedia.image' },
            ],
        },
        {
            transformFn: transformSDKAddressToRESTAddress,
            paths: [
                { path: 'service.locations.calculatedAddress' },
                { path: 'service.locations.business.address' },
                { path: 'service.locations.custom.address' },
            ],
        },
        {
            transformFn: transformSDKPageURLV2ToRESTPageURLV2,
            paths: [
                { path: 'service.urls.servicePage' },
                { path: 'service.urls.bookingPage' },
                { path: 'service.urls.calendarPage' },
            ],
        },
    ]);
    const reqOpts = ambassadorWixBookingsServicesV2Service.bulkUpdateServicesByFilter(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(result.data);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { filter: '$[0]', service: '$[1].service' },
            singleArgumentUnchanged: false,
        }, ['filter', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Deletes a service.
 * @public
 * @documentationMaturity preview
 * @requiredField serviceId
 * @param options - Allows you to configure how to handle the deleted service's future sessions and how to notify the sessions participants.
 * @permissionId BOOKINGS.SERVICES_DELETE
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 */
export async function deleteService(serviceId, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        serviceId: serviceId,
        preserveFutureSessionsWithParticipants: options?.preserveFutureSessionsWithParticipants,
        participantNotification: options?.participantNotification,
    });
    const reqOpts = ambassadorWixBookingsServicesV2Service.deleteService(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                serviceId: '$[0]',
                preserveFutureSessionsWithParticipants: '$[1].preserveFutureSessionsWithParticipants',
                participantNotification: '$[1].participantNotification',
            },
            singleArgumentUnchanged: false,
        }, ['serviceId', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Deletes multiple services.
 * @param ids - Ids of the services for deletion.
 * @public
 * @documentationMaturity preview
 * @requiredField ids
 * @permissionId BOOKINGS.SERVICES_DELETE
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 */
export async function bulkDeleteServices(ids, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        ids: ids,
        preserveFutureSessionsWithParticipants: options?.preserveFutureSessionsWithParticipants,
        participantNotification: options?.participantNotification,
    });
    const reqOpts = ambassadorWixBookingsServicesV2Service.bulkDeleteServices(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'results.item.media.items.image' },
                    { path: 'results.item.media.mainMedia.image' },
                    { path: 'results.item.media.coverMedia.image' },
                    { path: 'results.item.staffMembers.mainMedia.image' },
                    {
                        path: 'results.item.staffMemberDetails.staffMembers.mainMedia.image',
                    },
                ],
            },
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [
                    { path: 'results.item.locations.calculatedAddress' },
                    { path: 'results.item.locations.business.address' },
                    { path: 'results.item.locations.custom.address' },
                ],
            },
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [
                    { path: 'results.item.urls.servicePage' },
                    { path: 'results.item.urls.bookingPage' },
                    { path: 'results.item.urls.calendarPage' },
                ],
            },
        ]));
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                ids: '$[0]',
                preserveFutureSessionsWithParticipants: '$[1].preserveFutureSessionsWithParticipants',
                participantNotification: '$[1].participantNotification',
            },
            singleArgumentUnchanged: false,
        }, ['ids', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Deletes multiple services by filter.
 * @param filter - Filter to identify the services that need to be deleted.
 * @public
 * @documentationMaturity preview
 * @requiredField filter
 * @permissionId BOOKINGS.SERVICES_DELETE
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 */
export async function bulkDeleteServicesByFilter(filter, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        filter: filter,
        preserveFutureSessionsWithParticipants: options?.preserveFutureSessionsWithParticipants,
        participantNotification: options?.participantNotification,
    });
    const reqOpts = ambassadorWixBookingsServicesV2Service.bulkDeleteServicesByFilter(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(result.data);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                filter: '$[0]',
                preserveFutureSessionsWithParticipants: '$[1].preserveFutureSessionsWithParticipants',
                participantNotification: '$[1].participantNotification',
            },
            singleArgumentUnchanged: false,
        }, ['filter', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Retrieves a list of up to 100 services, given the provided paging, filtering, and sorting.
 * `queryServices()` runs with these defaults, which you can override:
 * + `paging.limit` is `100`.
 * + `paging.offset` is `0`.
 *
 *
 * >**Notes:**
 * > + Use UTC format when filtering with dates.
 * > + Only 1 use of each filter in the same query is supported. If a filter is defined more than once in a query, only the first occurrence is processed.
 * @public
 * @documentationMaturity preview
 * @permissionScope Read Bookings - Public Data
 * @permissionScopeId SCOPE.DC-BOOKINGS.READ-BOOKINGS-PUBLIC
 * @permissionScope Manage Bookings Services and Settings
 * @permissionScopeId SCOPE.BOOKINGS.CONFIGURATION
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Read Bookings - Including Participants
 * @permissionScopeId SCOPE.DC-BOOKINGS.READ-BOOKINGS-SENSITIVE
 * @permissionScope Read Bookings - all read permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.READ-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @permissionId BOOKINGS.SERVICES_READ
 * @applicableIdentity APP
 * @applicableIdentity VISITOR
 */
export function queryServices(options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    return queryBuilder({
        func: async (payload) => {
            const reqOpts = ambassadorWixBookingsServicesV2Service.queryServices({
                ...payload,
                ...(options ?? {}),
            });
            sideEffects?.onSiteCall?.();
            try {
                const result = await httpClient.request(reqOpts);
                sideEffects?.onSuccess?.(result);
                return result;
            }
            catch (err) {
                sideEffects?.onError?.(err);
                throw err;
            }
        },
        requestTransformer: (query) => {
            const args = [query, options];
            return renameKeysFromSDKRequestToRESTRequest({
                ...args?.[1],
                query: args?.[0],
            });
        },
        responseTransformer: ({ data }) => {
            const transformedData = renameKeysFromRESTResponseToSDKResponse(transformPaths(data, [
                {
                    transformFn: transformRESTImageToSDKImage,
                    paths: [
                        { path: 'services.media.items.image' },
                        { path: 'services.media.mainMedia.image' },
                        { path: 'services.media.coverMedia.image' },
                        { path: 'services.staffMembers.mainMedia.image' },
                        {
                            path: 'services.staffMemberDetails.staffMembers.mainMedia.image',
                        },
                    ],
                },
                {
                    transformFn: transformRESTAddressToSDKAddress,
                    paths: [
                        { path: 'services.locations.calculatedAddress' },
                        { path: 'services.locations.business.address' },
                        { path: 'services.locations.custom.address' },
                    ],
                },
                {
                    transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                    paths: [
                        { path: 'services.urls.servicePage' },
                        { path: 'services.urls.bookingPage' },
                        { path: 'services.urls.calendarPage' },
                    ],
                },
            ]));
            return {
                items: transformedData?.services,
                pagingMetadata: transformedData?.pagingMetadata,
            };
        },
        errorTransformer: (err) => {
            const transformedError = sdkTransformError(err, {
                spreadPathsToArguments: {},
                explicitPathsToArguments: { query: '$[0]' },
                singleArgumentUnchanged: false,
            });
            throw transformedError;
        },
        pagingMethod: 'OFFSET',
        transformationPaths: {},
    });
}
/**
 * Retrieves a list of up to 100 services, given the provided query string,
 * and paging.
 * @param search - WQL, search or aggregation expression.
 * @public
 * @documentationMaturity preview
 * @requiredField search
 * @permissionId BOOKINGS.SERVICES_READ
 * @permissionScope Read Bookings - Public Data
 * @permissionScopeId SCOPE.DC-BOOKINGS.READ-BOOKINGS-PUBLIC
 * @permissionScope Manage Bookings Services and Settings
 * @permissionScopeId SCOPE.BOOKINGS.CONFIGURATION
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Read Bookings - Including Participants
 * @permissionScopeId SCOPE.DC-BOOKINGS.READ-BOOKINGS-SENSITIVE
 * @permissionScope Read Bookings - all read permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.READ-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 * @applicableIdentity VISITOR
 */
export async function searchServices(search) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = renameKeysFromSDKRequestToRESTRequest({ search: search });
    const reqOpts = ambassadorWixBookingsServicesV2Service.searchServices(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'services.media.items.image' },
                    { path: 'services.media.mainMedia.image' },
                    { path: 'services.media.coverMedia.image' },
                    { path: 'services.staffMembers.mainMedia.image' },
                    {
                        path: 'services.staffMemberDetails.staffMembers.mainMedia.image',
                    },
                ],
            },
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [
                    { path: 'services.locations.calculatedAddress' },
                    { path: 'services.locations.business.address' },
                    { path: 'services.locations.custom.address' },
                ],
            },
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [
                    { path: 'services.urls.servicePage' },
                    { path: 'services.urls.bookingPage' },
                    { path: 'services.urls.calendarPage' },
                ],
            },
        ]));
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { search: '$[0]' },
            singleArgumentUnchanged: false,
        }, ['search']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Retrieves a list of up to 100 policies, given the provided paging,
 * filtering, and sorting.
 *
 *
 * Define queries using [WQL - Wix Query
 * Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
 * For field support for filters and sorting, see [Supported Filters and
 * Sorting](https://dev.wix.com/api/rest/wix-bookings/services-v2/supported-filters-and-sorting).
 *
 * To retrieve all policies use an empty query:
 *
 * ```javascript
 * {
 * "query": {}
 * }
 * ```
 * `Query Policies` runs with these defaults, which you can override:
 * + `paging.limit` is `100`.
 * + `paging.offset` is `0`.
 *
 *
 * >**Notes:**
 * > + Use UTC format when filtering with dates.
 * > + Only 1 use of each filter in the same query is supported. If a filter
 * is defined more than once in a query, only the first occurrence is
 * processed.
 * @param query - WQL expression.
 * @public
 * @documentationMaturity preview
 * @requiredField query
 * @permissionId BOOKINGS.BOOKING_POLICY_READ
 * @permissionId BOOKINGS.SERVICES_READ
 * @permissionScope Read Bookings - Public Data
 * @permissionScopeId SCOPE.DC-BOOKINGS.READ-BOOKINGS-PUBLIC
 * @permissionScope Manage Bookings Services and Settings
 * @permissionScopeId SCOPE.BOOKINGS.CONFIGURATION
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Read Bookings - Including Participants
 * @permissionScopeId SCOPE.DC-BOOKINGS.READ-BOOKINGS-SENSITIVE
 * @permissionScope Read Bookings - all read permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.READ-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @permissionScope Read Bookings - Public Data
 * @permissionScopeId SCOPE.DC-BOOKINGS.READ-BOOKINGS-PUBLIC
 * @permissionScope Manage Bookings Services and Settings
 * @permissionScopeId SCOPE.BOOKINGS.CONFIGURATION
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Read Bookings - Including Participants
 * @permissionScopeId SCOPE.DC-BOOKINGS.READ-BOOKINGS-SENSITIVE
 * @permissionScope Read Bookings - all read permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.READ-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 * @applicableIdentity VISITOR
 */
export async function queryPolicies(query) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = renameKeysFromSDKRequestToRESTRequest({ query: query });
    const reqOpts = ambassadorWixBookingsServicesV2Service.queryPolicies(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'bookingPolicies.services.media.items.image' },
                    { path: 'bookingPolicies.services.media.mainMedia.image' },
                    { path: 'bookingPolicies.services.media.coverMedia.image' },
                    { path: 'bookingPolicies.services.staffMembers.mainMedia.image' },
                    {
                        path: 'bookingPolicies.services.staffMemberDetails.staffMembers.mainMedia.image',
                    },
                ],
            },
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [
                    { path: 'bookingPolicies.services.locations.calculatedAddress' },
                    { path: 'bookingPolicies.services.locations.business.address' },
                    { path: 'bookingPolicies.services.locations.custom.address' },
                ],
            },
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [
                    { path: 'bookingPolicies.services.urls.servicePage' },
                    { path: 'bookingPolicies.services.urls.bookingPage' },
                    { path: 'bookingPolicies.services.urls.calendarPage' },
                ],
            },
        ]));
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { query: '$[0]' },
            singleArgumentUnchanged: false,
        }, ['query']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Retrieves the number of services that match the provided filters.
 * @public
 * @documentationMaturity preview
 * @permissionId BOOKINGS.SERVICES_COUNT
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 */
export async function countServices(options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        filter: options?.filter,
    });
    const reqOpts = ambassadorWixBookingsServicesV2Service.countServices(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(result.data);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { filter: '$[0].filter' },
            singleArgumentUnchanged: false,
        }, ['options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Query locations that exist on services.
 * @public
 * @documentationMaturity preview
 * @permissionId BOOKINGS.SERVICES_READ
 * @permissionScope Read Bookings - Public Data
 * @permissionScopeId SCOPE.DC-BOOKINGS.READ-BOOKINGS-PUBLIC
 * @permissionScope Manage Bookings Services and Settings
 * @permissionScopeId SCOPE.BOOKINGS.CONFIGURATION
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Read Bookings - Including Participants
 * @permissionScopeId SCOPE.DC-BOOKINGS.READ-BOOKINGS-SENSITIVE
 * @permissionScope Read Bookings - all read permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.READ-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 * @applicableIdentity VISITOR
 */
export async function queryLocations(options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        filter: options?.filter,
    });
    const reqOpts = ambassadorWixBookingsServicesV2Service.queryLocations(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [
                    { path: 'businessLocations.locations.calculatedAddress' },
                    { path: 'businessLocations.locations.business.address' },
                    { path: 'businessLocations.locations.custom.address' },
                ],
            },
        ]));
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { filter: '$[0].filter' },
            singleArgumentUnchanged: false,
        }, ['options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Query categories that exist on services.
 * @public
 * @documentationMaturity preview
 * @permissionId BOOKINGS.SERVICES_READ
 * @permissionScope Read Bookings - Public Data
 * @permissionScopeId SCOPE.DC-BOOKINGS.READ-BOOKINGS-PUBLIC
 * @permissionScope Manage Bookings Services and Settings
 * @permissionScopeId SCOPE.BOOKINGS.CONFIGURATION
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Read Bookings - Including Participants
 * @permissionScopeId SCOPE.DC-BOOKINGS.READ-BOOKINGS-SENSITIVE
 * @permissionScope Read Bookings - all read permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.READ-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 * @applicableIdentity VISITOR
 */
export async function queryCategories(options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[1];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        filter: options?.filter,
    });
    const reqOpts = ambassadorWixBookingsServicesV2Service.queryCategories(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(result.data);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { filter: '$[0].filter' },
            singleArgumentUnchanged: false,
        }, ['options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Change the locations this service is offered at.
 * Changing locations may have impact on existing sessions and their
 * participants. When removing locations from a service, this endpoint
 * requires stating what to do with existing sessions occurring at the removed
 * locations.
 * @param serviceId - ID of the service.
 * @param locations - The locations you specify replace the existing service locations.
 * @public
 * @documentationMaturity preview
 * @requiredField locations
 * @requiredField serviceId
 * @permissionId BOOKINGS.SERVICES_LOCATIONS_SET
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 */
export async function setServiceLocations(serviceId, locations, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[3];
    const payload = transformPaths(renameKeysFromSDKRequestToRESTRequest({
        serviceId: serviceId,
        locations: locations,
        removedLocationSessionsAction: options?.removedLocationSessionsAction,
        participantNotification: options?.participantNotification,
    }), [
        {
            transformFn: transformSDKAddressToRESTAddress,
            paths: [
                { path: 'locations.calculatedAddress' },
                { path: 'locations.business.address' },
                { path: 'locations.custom.address' },
                {
                    path: 'removedLocationSessionsAction.moveToLocationOptions.newLocation.calculatedAddress',
                },
                {
                    path: 'removedLocationSessionsAction.moveToLocationOptions.newLocation.business.address',
                },
                {
                    path: 'removedLocationSessionsAction.moveToLocationOptions.newLocation.custom.address',
                },
            ],
        },
    ]);
    const reqOpts = ambassadorWixBookingsServicesV2Service.setServiceLocations(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'service.media.items.image' },
                    { path: 'service.media.mainMedia.image' },
                    { path: 'service.media.coverMedia.image' },
                    { path: 'service.staffMembers.mainMedia.image' },
                    { path: 'service.staffMemberDetails.staffMembers.mainMedia.image' },
                ],
            },
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [
                    { path: 'service.locations.calculatedAddress' },
                    { path: 'service.locations.business.address' },
                    { path: 'service.locations.custom.address' },
                ],
            },
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [
                    { path: 'service.urls.servicePage' },
                    { path: 'service.urls.bookingPage' },
                    { path: 'service.urls.calendarPage' },
                ],
            },
        ]));
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                serviceId: '$[0]',
                locations: '$[1]',
                removedLocationSessionsAction: '$[2].removedLocationSessionsAction',
                participantNotification: '$[2].participantNotification',
            },
            singleArgumentUnchanged: false,
        }, ['serviceId', 'locations', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Enables specific [pricing
 * plans](https://dev.wix.com/api/rest/wix-pricing-plans/pricing-plans/plans/plan-object)
 * as payment methods for a service. This API enables customers to pay for the
 * service using one of the specified pricing plans.
 * @public
 * @documentationMaturity preview
 * @requiredField pricingPlanIds
 * @requiredField serviceId
 * @permissionId BOOKINGS.SERVICES_PRICING_PLANS_ADD
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 */
export async function enablePricingPlansForService(serviceId, pricingPlanIds) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        serviceId: serviceId,
        pricingPlanIds: pricingPlanIds,
    });
    const reqOpts = ambassadorWixBookingsServicesV2Service.enablePricingPlansForService(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'service.media.items.image' },
                    { path: 'service.media.mainMedia.image' },
                    { path: 'service.media.coverMedia.image' },
                    { path: 'service.staffMembers.mainMedia.image' },
                    { path: 'service.staffMemberDetails.staffMembers.mainMedia.image' },
                ],
            },
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [
                    { path: 'service.locations.calculatedAddress' },
                    { path: 'service.locations.business.address' },
                    { path: 'service.locations.custom.address' },
                ],
            },
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [
                    { path: 'service.urls.servicePage' },
                    { path: 'service.urls.bookingPage' },
                    { path: 'service.urls.calendarPage' },
                ],
            },
        ]));
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { serviceId: '$[0]', pricingPlanIds: '$[1]' },
            singleArgumentUnchanged: false,
        }, ['serviceId', 'pricingPlanIds']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Disables specific [pricing
 * plans](https://dev.wix.com/api/rest/wix-pricing-plans/pricing-plans/plans/plan-object)
 * as payment methods for a service. Customers can't pay for the service using
 * a removed pricing plan. Existing payments with a removed plan aren't
 * affected.
 * @public
 * @documentationMaturity preview
 * @requiredField serviceId
 * @permissionId BOOKINGS.SERVICES_PRICING_PLANS_REMOVE
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 */
export async function disablePricingPlansForService(serviceId, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        serviceId: serviceId,
        pricingPlanIds: options?.pricingPlanIds,
    });
    const reqOpts = ambassadorWixBookingsServicesV2Service.disablePricingPlansForService(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'service.media.items.image' },
                    { path: 'service.media.mainMedia.image' },
                    { path: 'service.media.coverMedia.image' },
                    { path: 'service.staffMembers.mainMedia.image' },
                    { path: 'service.staffMemberDetails.staffMembers.mainMedia.image' },
                ],
            },
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [
                    { path: 'service.locations.calculatedAddress' },
                    { path: 'service.locations.business.address' },
                    { path: 'service.locations.custom.address' },
                ],
            },
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [
                    { path: 'service.urls.servicePage' },
                    { path: 'service.urls.bookingPage' },
                    { path: 'service.urls.calendarPage' },
                ],
            },
        ]));
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                serviceId: '$[0]',
                pricingPlanIds: '$[1].pricingPlanIds',
            },
            singleArgumentUnchanged: false,
        }, ['serviceId', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Sets a custom (user-defined) slug for the various service pages.
 * The call may fail if there's another service with the same slug, either by
 * past name or by a custom slug.
 * @public
 * @documentationMaturity preview
 * @requiredField serviceId
 * @requiredField slugName
 * @permissionId BOOKINGS.SERVICES_CUSTOM_SLUGS_SET
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 */
export async function setCustomSlug(serviceId, slugName) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        serviceId: serviceId,
        slugName: slugName,
    });
    const reqOpts = ambassadorWixBookingsServicesV2Service.setCustomSlug(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'service.media.items.image' },
                    { path: 'service.media.mainMedia.image' },
                    { path: 'service.media.coverMedia.image' },
                    { path: 'service.staffMembers.mainMedia.image' },
                    { path: 'service.staffMemberDetails.staffMembers.mainMedia.image' },
                ],
            },
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [
                    { path: 'service.locations.calculatedAddress' },
                    { path: 'service.locations.business.address' },
                    { path: 'service.locations.custom.address' },
                ],
            },
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [
                    { path: 'service.urls.servicePage' },
                    { path: 'service.urls.bookingPage' },
                    { path: 'service.urls.calendarPage' },
                ],
            },
        ]));
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: { serviceId: '$[0]', slugName: '$[1]' },
            singleArgumentUnchanged: false,
        }, ['serviceId', 'slugName']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Validate a custom (user-defined) slug, making sure no other service uses
 * the same slug. The call may fail if there's another service with the same
 * slug, either by past name or by a custom set slug.
 * @public
 * @documentationMaturity preview
 * @requiredField options
 * @requiredField options.slugName
 * @requiredField serviceId
 * @permissionId BOOKINGS.SERVICES_CUSTOM_SLUGS_SET
 * @permissionScope Manage Bookings
 * @permissionScopeId SCOPE.DC-BOOKINGS.MANAGE-BOOKINGS
 * @permissionScope Manage Bookings - all permissions
 * @permissionScopeId SCOPE.DC-BOOKINGS-MEGA.MANAGE-BOOKINGS
 * @applicableIdentity APP
 */
export async function validateSlug(serviceId, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        serviceId: serviceId,
        slugName: options?.slugName,
    });
    const reqOpts = ambassadorWixBookingsServicesV2Service.validateSlug(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(result.data);
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                serviceId: '$[0]',
                slugName: '$[1].slugName',
            },
            singleArgumentUnchanged: false,
        }, ['serviceId', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
/**
 * Clones a service.
 * @public
 * @documentationMaturity preview
 * @requiredField sourceServiceId
 * @permissionId BOOKINGS.SERVICE_CLONE
 * @permissionScope Manage Bookings Services and Settings
 * @permissionScopeId SCOPE.BOOKINGS.CONFIGURATION
 * @applicableIdentity APP
 */
export async function cloneService(sourceServiceId, options) {
    // @ts-ignore
    const { httpClient, sideEffects } = arguments[2];
    const payload = renameKeysFromSDKRequestToRESTRequest({
        sourceServiceId: sourceServiceId,
        copyRecurringSessions: options?.copyRecurringSessions,
        copyPricingPlans: options?.copyPricingPlans,
        hideService: options?.hideService,
        cloneServiceName: options?.cloneServiceName,
    });
    const reqOpts = ambassadorWixBookingsServicesV2Service.cloneService(payload);
    sideEffects?.onSiteCall?.();
    try {
        const result = await httpClient.request(reqOpts);
        sideEffects?.onSuccess?.(result);
        return renameKeysFromRESTResponseToSDKResponse(transformPaths(result.data, [
            {
                transformFn: transformRESTImageToSDKImage,
                paths: [
                    { path: 'service.media.items.image' },
                    { path: 'service.media.mainMedia.image' },
                    { path: 'service.media.coverMedia.image' },
                    { path: 'service.staffMembers.mainMedia.image' },
                    { path: 'service.staffMemberDetails.staffMembers.mainMedia.image' },
                ],
            },
            {
                transformFn: transformRESTAddressToSDKAddress,
                paths: [
                    { path: 'service.locations.calculatedAddress' },
                    { path: 'service.locations.business.address' },
                    { path: 'service.locations.custom.address' },
                ],
            },
            {
                transformFn: transformRESTPageURLV2ToSDKPageURLV2,
                paths: [
                    { path: 'service.urls.servicePage' },
                    { path: 'service.urls.bookingPage' },
                    { path: 'service.urls.calendarPage' },
                ],
            },
        ]));
    }
    catch (err) {
        const transformedError = sdkTransformError(err, {
            spreadPathsToArguments: {},
            explicitPathsToArguments: {
                sourceServiceId: '$[0]',
                copyRecurringSessions: '$[1].copyRecurringSessions',
                copyPricingPlans: '$[1].copyPricingPlans',
                hideService: '$[1].hideService',
                cloneServiceName: '$[1].cloneServiceName',
            },
            singleArgumentUnchanged: false,
        }, ['sourceServiceId', 'options']);
        sideEffects?.onError?.(err);
        throw transformedError;
    }
}
//# sourceMappingURL=bookings-services-v2-service-services.universal.js.map